{
  "it": {
    "inspiration": {
      "actions": {
        "delete": "Elimina",
        "deleteMultipleInspirations": "Elimina...",
        "delete_cancel": "Annulla eliminazione",
        "goBackToInspirationLists": "Ispirazioni",
        "new": "Aggiungi foto"
      },
      "labels": {
        "move_to_upload": "Metta le foto nel riquadro qui sotto o faccia clic per caricarle.",
        "noInspirations": "Nessuna ispirazione ancora",
        "upload_autoclose": "Questa finestra si chiuderà automaticamente quando tutte le immagini saranno state caricate."
      },
      "toasts": {
        "upload_success": "{count} ispirazione caricata con successo | {count} ispirazioni caricate con successo"
      }
    }
  }
}
